import React from 'react'
import { formatPacificDateTimeParts } from '../utils/timezone'

interface FormattedDateTimeProps {
  dateString: string | null | undefined
}

/**
 * Renders a Pacific Time date/time with the date and time each in a no-wrap span,
 * so line breaks occur between them rather than mid-value (e.g. orphaning "PT").
 */
export const FormattedDateTime: React.FC<FormattedDateTimeProps> = ({ dateString }) => {
  const parts = formatPacificDateTimeParts(dateString)
  if (!parts) return <>N/A</>
  return (
    <>
      <span style={{ whiteSpace: 'nowrap' }}>{parts.date}</span>{' '}
      <span style={{ whiteSpace: 'nowrap' }}>{parts.time}</span>
    </>
  )
}
